import { gql } from "@apollo/client";
import { ESubmittalStatus } from "../../constants";

const QUERY_PROJECT_WORKFLOW_TEMPLATES_ID_NAME = gql`
  query GetTemplates {
    project_workflow_templates(where: { feature_id: { _eq: 2 } }) {
      id
      name
    }
  }
`;

const QUERY_GET_DB_TEMPLATES = gql`
  query GetMDBTemplates($feature_id: Int!) {
    project_workflow_templates(where: { feature_id: { _eq: $feature_id } }) {
      id
      name
      default
      disabled
      feature_id
      additional_offset
      float
      project_template_milestones(order_by: { sequence_no: asc }) {
        id
        sequence_no
        name
        milestone_action
        next_offset {
          name
          id
          duration
        }
      }
      updated_by
      updated_by_user {
        first_name
        email
        last_name
        id
      }
      updated_at
      created_by_user {
        email
        first_name
        last_name
      }
      created_at
      date_blocks_aggregate(
        where: { workflow_status: { _eq: "IN_PROGRESS" } }
      ) {
        aggregate {
          count
        }
      }
    }
  }
`;

const QUERY_PROJECT_FEATURE_CONFIGURATION = gql`
  query featureConfigurationThreshold(
    $where: project_feature_configurations_bool_exp = {}
  ) {
    project_feature_configurations(where: $where) {
      feature_id
      high_risk_threshold
      low_risk_threshold
    }
  }
`;

const QUERY_DISTRIBUTION_GROUP_LIST = gql`
  query DistributionGroups($where: distribution_group_bool_exp!) {
    distribution_group(where: $where, order_by: { name: asc }) {
      name
      id
      distribution_group_user {
        user {
          id
          email
          first_name
          last_name
          project_users {
            status_id
            project_role {
              name
            }
            subscription {
              organization_subscriptions {
                organization {
                  name
                }
              }
            }
            subscription_vendor {
              name
            }
          }
        }
      }
    }
  }
`;

const QUERY_GET_SUBMITTAL_DL_USERS = gql`
  query fetchSubmittalDistributionList(
    $where: submittal_distribution_list_bool_exp!
  ) {
    submittal_distribution_list(where: $where) {
      user_id
      dl_id
    }
  }
`;

const QUERY_USER_CONFIG_VIEWS = gql`
  query getAllUserView($feature_id: Int!) {
    project_feature_user_view(where: { feature_id: { _eq: $feature_id } }) {
      id
      name
      column_config
    }
  }
`;

const QUERY_GET_PROJECT_SPECS = gql`
  query Specs {
    spec_sections(order_by: { section_number: asc }) {
      title
      id
      section_number
      file_key
    }
  }
`;

const QUERY_GET_TIMEZONES = gql`
  query MyTimeZoneQuery {
    timezones {
      id
      timezone_id
      name
    }
  }
`;

const QUERY_PROJECT_AGG = gql`
  query GetProjectAggByName($where: project_bool_exp!) {
    project_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

const QUERY_USER_TYPE = gql`
  query GetUserTypes {
    user_types {
      id
      key
      name
    }
  }
`;

const QUERY_TRADE_USER_TYPE = gql`
  query GetTradeUserTypes {
    user_types(where: { key: { _neq: "GENERAL_CONTRACTOR" } }) {
      id
      key
      name
    }
  }
`;

const QUERY_GET_VENDOR_ID = gql`
  query GetVendorIdQuery($userId: uuid!) {
    project_users(where: { user_id: { _eq: $userId } }) {
      subscription_vendor {
        id
      }
    }
  }
`;
const QUERY_GET_SPEC_SECTION_BY_SECTION_NUMBER = gql`
  query GetSpecSectionByNumber($sectionNumber: String!) {
    spec_sections(where: { section_number: { _eq: $sectionNumber } }) {
      section_number
      section_name
      title
    }
  }
`;

const QUERY_GET_PROJECT_USER_STATUS_ID = gql`
  query PrjectUsersQuery($where: project_users_bool_exp!) {
    project_users(where: $where) {
      status_id
      user {
        email
      }
    }
  }
`;

const QUERY_GET_SUBSCRIPTION_USER_STATUS_ID = gql`
  query SubscriptionUsersQuery($where: subscription_users_bool_exp!) {
    subscription_users(where: $where) {
      status_id
      user {
        email
      }
    }
  }
`;

const QUERY_GET_MATERIAL = gql`
  query GetMaterial($where: material_bool_exp) {
    material(where: $where) {
      id
    }
  }
`;

const QUERY_NON_SCHEDULE_IMPORT_PERMISSION_USR_GANTT_TASKS = gql`
  query GetSchedulerList {
    gantt_tasks {
      id
      type
      text
      duration
      end_date
      start_date
      source_task_id
      import_log_id
      parent
      critical
      total_slack
      total_slack_computed
      progress
      actual_start_date
      actual_finish_date
    }
  }
`;

const QUERY_GANTT_TASKS_LIST = gql`
  query GetSchedulerList {
    gantt_tasks {
      id
      type
      text
      duration
      end_date
      start_date
      source_task_id
      import_log_id
      parent
      submittal_id
      submittal {
        title
        description
        assignee
        workflow_status
      }
      material_id
      material {
        name
        material_assignee {
          id
        }
        status
      }
      critical
      total_slack
      total_slack_computed
      progress
      actual_start_date
      actual_finish_date
    }
  }
`;

const QUERY_SCHEDULER_TASK_LINK_LIST = gql`
  query GetSchedulerTaskLinkList {
    gantt_links {
      id
      source
      target
      type
    }
  }
`;

const QUERY_GET_SUBSCRIPTION_DETAILS = gql`
  query GetSubscriptionDetail($id: uuid!) {
    subscription_by_pk(id: $id) {
      id
      name
      paid
    }
  }
`;

const QUERY_SUBMITTAL_WORKFLOW_RESPONSES = gql`
  query SubmittalReviewResponse {
    submittal_response {
      key
      response
      id
    }
  }
`;

const QUERY_MASTER_UNITS = gql`
  query UnitQuery {
    material_quantity_unit {
      id
      measurement
      unit
    }
    material_size_unit {
      id
      measurement
      unit
    }
  }
`;

const QUERY_SUBMITTAL_TYPES = gql`
  query SubmittalTypes {
    configurations_value(order_by: { value: asc }) {
      value
      id
      configuration_master_id
    }
  }
`;

const QUERY_GET_SUBMITTALL_DISTRIBUTION_LIST = gql`
  query GetSubmittalDistributionList(
    $where: submittal_distribution_list_bool_exp!
  ) {
    submittal_distribution_list(where: $where) {
      dl_id
      user_id
      submittal_id
    }
  }
`;

const QUERY_PROJECT_USERS = gql`
  query ProjectUsers($where: project_users_bool_exp) {
    project_users(where: $where, order_by: { updated_at: desc }) {
      updated_at
      user_id
      subscription_id
      user_type {
        id
        name
      }
      user {
        email
        first_name
        id
        status_id
        last_name
        phone
      }
      project_role {
        id
        key
        name
      }
      subscription_vendor {
        id
        name
        partner_subscription_id
        project_vendors {
          type_id
          project_vendors_company_status {
            status
          }
          project_vendors_type {
            key
            name
            id
          }
        }
      }
      subscription {
        organization_subscriptions {
          organization {
            name
            id
          }
        }
      }
      status_id
      external
      external_source_id
      project_integration_users {
        full_source_name
      }
      subscription_user {
        user_source_infos {
          full_source_name
        }
      }
    }
  }
`;

const QUERY_SUBMITTALS_LINKING_TABLE = gql`
  query SubmittalsLinking {
    submittals(
      where: { deleted: { _eq: false }, workflow_status: { _neq: ${ESubmittalStatus.VOID} } }
    ) {
      id
      submittal_id
      title
      description
      spec_name
      spec_no
      material_tracking
      status
      deleted_from_source
      submittal_type {
        id
        value
      }
      submittal_schedule_links {
        linked_to_end_date
        gantt_task {
          id
          source_task_id
          text
        }
      }
      submittal_material_links {
        material {
          spec_section_name
          spec_section_no
          name
          material_id
          id
          actual_ROJ
          implicit
          actual_fabrication_start_date
          actual_material_release_date
          actual_shipment_date
          material_schedule_links {
            linked_to_end_date
            gantt_task {
              id
              source_task_id
              text
            }
          }
          material_date_block {
            ROJ_date
            fabrication_duration_offset
            fabrication_start_date
            lead_time_offset
            material_PO_date
            material_PO_fabrication_offset
            on_site_storage_offset
            shipment_date
            material_id
          }
        }
      }
      submittal_date_block {
        ext_review_offset
        final_gc_review_offset
        gc_review_offset
        submittal_prep_offset
        float
        assigned_date
        ext_review_completed_date
        ext_review_submitted_date
        submittal_distributed_date
        trade_partner_submitted_date
        submittal_id
        actual_assigned_date
        actual_ext_review_completed_date
        actual_ext_review_submitted_date
        actual_submittal_distributed_date
        actual_trade_partner_submitted_date
      }
    }
  }
`;

const QUERY_PROJECT_MATERIALS = gql`
  query ProjectMaterials {
    material(where: { implicit: { _neq: true } }) {
      id
      material_id
      name
      spec_section_no
      spec_section_name
      actual_material_release_date
      material_schedule_links {
        linked_to_end_date
        offset_duration
        linked_offset_date
        gantt_task {
          id
          source_task_id
          text
        }
      }
    }
  }
`;

const QUERY_ACTIVE_PROJECT_USERS = gql`
  query ProjectUsers($where: project_users_bool_exp!) {
    project_users(
      where: $where
      order_by: { user: { first_name: asc, last_name: asc } }
    ) {
      status_id
      user {
        email
        first_name
        id
        status_id
        last_name
        phone
      }
    }
  }
`;

const QUERY_GANTT_TASKS_LIST_FOR_PROCUREMENT = gql`
  query GetSchedulerList {
    gantt_tasks {
      id
      type
      text
      duration
      end_date
      start_date
      source_task_id
      submittal_schedule_links {
        submittal_id
        submittal {
          id
          submittal_id
          spec_no
          title
          revision
          workflow_status
          assignee
          gc_reviewer
          design_reviewer
          responsible_contractor
          gc_reviewer_user {
            id
            first_name
            last_name
          }
          design_reviewer_user {
            id
            first_name
            last_name
          }
          responsible_contractor_vendor {
            id
            name
          }
          submittal_assignee {
            email
            first_name
            last_name
          }
          responsible_contractor
          responsible_contractor_vendor {
            id
            address
            name
            vendor_no
          }
          submittal_date_block {
            assigned_date
            submittal_distributed_date
          }
          submittal_material_links {
            material_id
          }
          date_block_submittals {
            planned_milestone_1
            planned_milestone_5
          }
        }
      }
      material_schedule_links {
        linked_to_end_date
        material_id
        material {
          id
          material_id
          name
          assignee
          status
          material_assignee {
            first_name
            last_name
          }
          material_date_block {
            material_PO_date
            ROJ_date
          }
          date_block_materials {
            planned_milestone_1
            planned_milestone_4
          }
          implicit
          submittal_material_links {
            submittal_id
            submittal {
              id
              submittal_id
              spec_no
              title
              revision
              workflow_status
              assignee
              gc_reviewer
              design_reviewer
              responsible_contractor
              gc_reviewer_user {
                id
                first_name
                last_name
              }
              design_reviewer_user {
                id
                first_name
                last_name
              }
              responsible_contractor_vendor {
                id
                name
              }
              submittal_assignee {
                email
                first_name
                last_name
              }
              responsible_contractor
              responsible_contractor_vendor {
                id
                address
                name
                vendor_no
              }
              submittal_date_block {
                assigned_date
                submittal_distributed_date
              }
            }
          }
        }
      }
    }
  }
`;

const QUERY_CALENDAR_HOLIDAY_LIST = gql`
  query CalendarHolidayList($projectId: uuid) {
    gantt_calendar(
      where: { deleted: { _eq: false }, project_id: { _eq: $projectId } }
      order_by: { created_at: desc }
    ) {
      calendar_holiday_lists(where: { deleted: { _eq: false } }) {
        date
      }
    }
  }
`;

const QUERY_PROJECT_DETAILS_PK_SETTINGS = gql`
  query ProjectDetails($projectId: uuid!) {
    project_by_pk(id: $projectId) {
      id
      mode
      spec_section
      name
      timezone {
        timezone_id
        name
      }
      new_entity_model_enabled
    }
  }
`;

// Below query needs subscription token
const QUERY_USER_PROFILE_INFO = gql`
  query UserProfileInfo($where: subscription_users_bool_exp) {
    subscription_users(where: $where) {
      user {
        first_name
        last_name
        email
        phone
      }
      subscription {
        name
        default_vendor_id
        organization_subscriptions {
          organization {
            name
          }
        }
      }
      user_source_infos {
        full_source_name
      }
    }
  }
`;

// Below query needs project token
const QUERY_USER_PROJECT_PROFILE_INFO = gql`
  query UserProjectProfileInfo($where: subscription_users_bool_exp) {
    subscription_users(where: $where) {
      user {
        first_name
        last_name
        email
        phone
        project_users {
          subscription_vendor {
            name
            id
          }
        }
      }
    }
  }
`;

const QUERY_PROJECT_VENDORS = gql`
  query ProjectQuery($where: project_vendors_bool_exp = {}) {
    project_vendors(where: $where) {
      vendor_id
      subscription_vendor {
        partner_subscription_id
        name
        project_users {
          external
        }
        vendor_source_infos {
          full_source_name
        }
      }
      type_id
      project_vendors_type {
        id
        name
        key
      }
      status
      project_vendors_company_status {
        status
        id
      }
    }
  }
`;

const QUERY_COMPANY_LIST = gql`
  query CompanyList($where: subscription_vendors_bool_exp = {}) {
    subscription_vendors(where: $where, order_by: { name: asc }) {
      id
      name
      address
      trade_partner_pocs(where: { deleted: { _eq: false } }) {
        email
        first_name
        last_name
        phone
        id
      }
      project_vendors {
        type_id
        project_vendors_company_status {
          status
        }
      }
      vendor_source_infos {
        full_source_name
      }
    }
  }
`;

const QUERY_PROJECT_INTEGRATION = gql`
  query GetProjectIntegrationKey {
    external_integrations {
      integration_key
      configuration
    }
  }
`;

const QUERY_PROJECT_INTEGRATION_USERS = gql`
  query GetProjectIntegrationUser {
    project_integration_users {
      id
      email
      first_name
      last_name
      vendor_id
      user {
        project_users {
          status_id
        }
      }
      project_integration_vendor {
        id
        name
      }
    }
  }
`;

const QUERY_PRODUCT_ENTITLEMENTS = gql`
  query ProductEntitlementsQuery {
    get_product_entitlements {
      enabled
      feature
    }
  }
`;

const QUERY_SAVED_COLUMN_HEADERS = gql`
  query SavedColumnHeaders($where: project_users_bool_exp) {
    project_users(where: $where) {
      project_id
      submittal_column_config
      material_column_config
    }
  }
`;

const QUERY_CALENDAR_LIST = gql`
  query CalendarList($projectId: uuid) {
    gantt_calendar(
      where: { deleted: { _eq: false }, project_id: { _eq: $projectId } }
      order_by: { created_at: desc }
    ) {
      id
      name
      description
      calendar_holiday_lists(where: { deleted: { _eq: false } }) {
        id
        country_code
        holiday_name
        date
      }
      work_shifts {
        id
        hours
        name
      }
      calendar_shift_mapping {
        id
        deleted
        work_day
        work_day_mapping {
          name
        }
        work_shift {
          name
          hours
        }
      }
    }
  }
`;

const QUERY_SUBMITTAL_RISK_REPORT_WF = gql`
  query SubmittalRiskReportWF(
    $where: submittal_cumulative_risk_report_wf_mode_view_interface_bool_exp
  ) {
    submittal_cumulative_risk_report_wf_mode_func(
      where: $where
      order_by: { submittal_id: asc }
    ) {
      id
      submittal_id
      assignee_user_id
      assignee_unregistered
      assignee_status
      date_block_submittals
      project_id
      responsible_contractor_id
      responsible_contractor_name
      spec_name
      spec_no
      status
      submittal_material_links
      submittal_schedule_links
      workflow_status
      title
      type
      history
      submitter_user_id
      gc_reviewer_user_id
      design_reviewer_user_id
      design_reviewer_unregistered
      submitter_unregistered
      risk_level
      deleted_from_source
    }
  }
`;
const QUERY_SUBMITTAL_RISK_REPORT_INTG = gql`
  query SubmittalRiskReportWF(
    $where: submittal_cumulative_risk_report_intg_mode_view_interface_bool_exp
  ) {
    submittal_cumulative_risk_report_intg_mode_func(
      where: $where
      order_by: { submittal_id: asc }
    ) {
      id
      submittal_id
      assignee_user_id
      assignee_status
      date_block_submittals
      project_id
      responsible_contractor_id
      responsible_contractor_name
      spec_name
      spec_no
      submittal_material_links
      submittal_schedule_links
      workflow_status
      title
      type
      actual_assigned_date
      actual_ext_review_completed_date
      actual_ext_review_submitted_date
      actual_submittal_distributed_date
      actual_trade_partner_submitted_date
      planned_ext_review_completed_date
      planned_submittal_distributed_date
      planned_trade_partner_submitted_date
      submitter_user_id
      gc_reviewer_user_id
      design_reviewer_user_id
      risk_level
      revision_date_blocks
      revision
      deleted_from_source
    }
  }
`;

const QUERY_RISK_REPORT_SUMMARY = gql`
  query RiskReportSummary {
    project_gc_cumulative_risk_report_summary_func {
      item_type
      risk_level
      count
    }
  }
`;

const QUERY_MATERIAL_RISK_REPORT = gql`
  query MaterialRiskReport(
    $where: material_cumulative_risk_report_view_interface_bool_exp
  ) {
    material_cumulative_risk_report_func(
      where: $where
      order_by: { material_id: asc }
    ) {
      assignee
      assignee_first_name
      assignee_last_name
      assignee_status
      date_block_materials
      id
      material_id
      material_schedule_links
      material_submitttal_links
      material_tag
      name
      project_id
      risk_level
      spec_section_name
      spec_section_no
      status
      trade_partner_name
      gc_representative
      gc_representative_first_name
      gc_representative_last_name
      gc_representative_status
    }
  }
`;

const QUERY_GET_TEMPLATE_PROJECTS = gql`
  query ProjectList($where: project_list_view_bool_exp = {}) {
    project_list_func(where: $where) {
      id
      name
    }
  }
`;

const QUERY_GET_ALL_LOCATIONS = gql`
  query GetAllLocationsSettings {
    location {
      id
      name
      parent_id
      order
      path
      created_at
      created_by
      project_id
      updated_at
      updated_by
    }
  }
`;

const QUERY_GET_SCHEDULE_VERSIONS = gql`
  query ScheduleVersions {
    schedule_import_details(
      order_by: { created_at: desc }
      where: { import_log: { import_type: { _eq: SCHEDULE } } }
    ) {
      id
      import_log_id
      is_active
      schedule_name
      schedule_date
      schedule_type
      activated_at
      created_at
      import_log {
        id
        resolved_values_s3_prefix
        source_values_s3_prefix
        created_at
        created_by_user {
          id
          first_name
          last_name
        }
      }
    }
  }
`;

const LINKED_SUBMITTALS = gql`
  query GetSubmittalDetails($where: feature_instance_bool_exp!) {
    submittals: feature_instance(where: $where) {
      id
      submittal_id: auto_inc_value
      title
      description
      feature_instance_spec_sections {
        spec_section {
          spec_no: section_number
          spec_name: title
          specification_id
        }
      }
      feature_submittals {
        material_tracking
        status
        submittal_type {
          id
          value
        }
      }
      deleted_from_source
      submittal_schedule_links: links_as_source(
        where: { target_feature_instance: { feature_type_id: { _eq: 9 } } }
      ) {
        link_type
        governing_link
        target_feature_instance {
          id
          source_task_id: number
          text: title
          feature_type_id
          feature_activities {
            duration
            end_date
            start_date
            import_log_id
            parent
            critical
            is_critical
            total_slack
            total_slack_computed
            progress
            actual_start_date
            actual_finish_date
          }
        }
      }
      submittal_material_links: links_as_source(
        where: { target_feature_instance: { feature_type_id: { _eq: 2 } } }
      ) {
        target_feature_instance {
          id
          implicit
          material_id: number
          name: title
          feature_type_id
          material_schedule_links: links_as_source(
            where: { target_feature_instance: { feature_type_id: { _eq: 9 } } }
          ) {
            governing_link
            created_at
            link_type
            offset_duration
            linked_offset_date
            reverse_dependency
            target_feature_instance {
              id
              source_task_id: number
              text: title
            }
          }
          schedule_material_links: links_as_target(
            where: {
              _or: [
                { source_feature_instance: { feature_type_id: { _eq: 9 } } }
              ]
            }
          ) {
            governing_link
            created_at
            link_type
            offset_duration
            linked_offset_date
            reverse_dependency
            target_feature_instance: source_feature_instance {
              id
              source_task_id: number
              text: title
            }
          }
          feature_workflow_instance {
            risk_level
            milestone_state
          }
          feature_instance_spec_sections {
            spec_section {
              section_number
              section_name
              status
              title
              specification_id
            }
          }
        }
      }
    }
  }
`;

const GANTT_TASKS = gql`
  query GetNewSchedulerList {
    gantt_tasks: feature_activities {
      feature_instance {
        id
        text: title
        source_task_id: number
      }
      type
      duration
      end_date
      start_date
      import_log_id
      parent
      critical
      total_slack
      total_slack_computed
      progress
      actual_start_date
      actual_finish_date
      __typename
    }
  }
`;

const FEATURE_ACTIVITY_BY_PK = gql`
  query FeatureActivityPkQuery($id: uuid!) {
    feature_activities_by_pk(feature_instance_id: $id) {
      start_date
      end_date
      actual_start_date
      actual_finish_date
      critical
      is_critical
      total_slack
      type
      progress
      duration
      total_slack_computed
      feature_instance {
        title
        number
      }
    }
  }
`;

const PROJECT_MATERIALS = gql`
  query GetNewProjectMaterials {
    material: feature_instance(
      where: {
        _and: [{ implicit: { _neq: true } }, { feature_type_id: { _eq: 2 } }]
      }
    ) {
      id
      material_id: auto_inc_value
      name: title
      feature_instance_spec_sections {
        spec_section {
          section_name
          section_number
          title
        }
      }
      material_schedule_links: links_as_source(
        where: { target_feature_instance: { feature_type_id: { _eq: 9 } } }
      ) {
        created_at
        governing_link
        reverse_dependency
        link_type
        offset_duration
        linked_offset_date
        gantt_task: target_feature_instance {
          id
          source_task_id: number
          text: title
        }
      }
      schedule_material_links: links_as_target(
        where: {
          _or: [{ source_feature_instance: { feature_type_id: { _eq: 9 } } }]
        }
      ) {
        governing_link
        created_at
        link_type
        offset_duration
        linked_offset_date
        reverse_dependency
        gantt_task: source_feature_instance {
          id
          source_task_id: number
          text: title
        }
      }
    }
  }
`;

export {
  QUERY_PROJECT_AGG,
  QUERY_USER_TYPE,
  QUERY_TRADE_USER_TYPE,
  QUERY_GET_VENDOR_ID,
  QUERY_GET_SPEC_SECTION_BY_SECTION_NUMBER,
  QUERY_GET_PROJECT_USER_STATUS_ID,
  QUERY_GET_SUBSCRIPTION_USER_STATUS_ID,
  QUERY_GET_MATERIAL,
  QUERY_GANTT_TASKS_LIST,
  QUERY_SCHEDULER_TASK_LINK_LIST,
  QUERY_GET_SUBSCRIPTION_DETAILS,
  QUERY_GET_SUBMITTALL_DISTRIBUTION_LIST,
  QUERY_PROJECT_USERS,
  QUERY_SUBMITTAL_WORKFLOW_RESPONSES,
  QUERY_SUBMITTAL_TYPES,
  QUERY_MASTER_UNITS,
  QUERY_SUBMITTALS_LINKING_TABLE,
  QUERY_PROJECT_MATERIALS,
  QUERY_ACTIVE_PROJECT_USERS,
  QUERY_GET_TIMEZONES,
  QUERY_GANTT_TASKS_LIST_FOR_PROCUREMENT,
  QUERY_CALENDAR_HOLIDAY_LIST,
  QUERY_NON_SCHEDULE_IMPORT_PERMISSION_USR_GANTT_TASKS,
  QUERY_PROJECT_DETAILS_PK_SETTINGS,
  QUERY_USER_PROFILE_INFO,
  QUERY_PROJECT_VENDORS,
  QUERY_COMPANY_LIST,
  QUERY_PROJECT_INTEGRATION,
  QUERY_PROJECT_INTEGRATION_USERS,
  QUERY_PRODUCT_ENTITLEMENTS,
  QUERY_DISTRIBUTION_GROUP_LIST,
  QUERY_GET_SUBMITTAL_DL_USERS,
  QUERY_PROJECT_FEATURE_CONFIGURATION,
  QUERY_USER_CONFIG_VIEWS,
  QUERY_GET_PROJECT_SPECS,
  QUERY_GET_DB_TEMPLATES,
  QUERY_PROJECT_WORKFLOW_TEMPLATES_ID_NAME,
  QUERY_SAVED_COLUMN_HEADERS,
  QUERY_CALENDAR_LIST,
  QUERY_SUBMITTAL_RISK_REPORT_WF,
  QUERY_SUBMITTAL_RISK_REPORT_INTG,
  QUERY_RISK_REPORT_SUMMARY,
  QUERY_MATERIAL_RISK_REPORT,
  QUERY_GET_TEMPLATE_PROJECTS,
  QUERY_GET_ALL_LOCATIONS,
  QUERY_GET_SCHEDULE_VERSIONS,
  LINKED_SUBMITTALS,
  GANTT_TASKS,
  FEATURE_ACTIVITY_BY_PK,
  PROJECT_MATERIALS,
  QUERY_USER_PROJECT_PROFILE_INFO
};
